// ============================================
// BOUT TIME — BRAND THEME
// Edit colours here to change the whole app
// ============================================

const brand = {
  // Core accent colours
  green: "#1B4332",
  greenLight: "rgba(27,67,50,0.10)",
  greenMid: "rgba(27,67,50,0.22)",
  greenBorder: "1px solid rgba(27,67,50,0.28)",
  greenStrong: "rgba(27,67,50,0.45)",

  coral: "#E6544C",
  coralLight: "rgba(230,84,76,0.12)",
  coralMid: "rgba(230,84,76,0.28)",
  coralBorder: "1px solid rgba(230,84,76,0.35)",

  // Light mode only
  pageBackground: "linear-gradient(180deg, #FAF3E8 0%, #F2E8D5 100%)",
  cardBackground: "rgba(255,255,255,0.90)",
  cardBorder: "1px solid rgba(27,67,50,0.10)",
  softBackground: "rgba(27,67,50,0.06)",
  pillBackground: "rgba(27,67,50,0.08)",
  pillBorder: "1px solid rgba(27,67,50,0.20)",
  primaryText: "#1A1A1A",
  secondaryText: "#5A5A5A",
  mutedText: "#8A8A8A",
  inputBackground: "rgba(255,255,255,0.95)",
  navBackground: "rgba(250,243,232,0.85)",
  navBorder: "1px solid rgba(27,67,50,0.12)",
  navText: "#5A5A5A",
  navActiveText: "#1B4332",
  modalBackground: "rgba(250,243,232,0.97)",
  planBackground: "rgba(27,67,50,0.06)",
  overlayBackground: "rgba(26,26,26,0.45)",
  elevatedBackground: "rgba(255,255,255,0.97)",
  accentColor: "#1B4332",
  accentLight: "rgba(27,67,50,0.09)",
  accentBorder: "1px solid rgba(27,67,50,0.45)",
  actionColor: "#E6544C",
  actionLight: "rgba(230,84,76,0.10)",
  actionBorder: "1px solid rgba(230,84,76,0.30)"
};

export function getBrandTheme() {
  return {
    // Backgrounds
    pageBackground: brand.pageBackground,
    cardBackground: brand.cardBackground,
    cardBorder: brand.cardBorder,
    softBackground: brand.softBackground,
    modalBackground: brand.modalBackground,
    planBackground: brand.planBackground,
    elevatedBackground: brand.elevatedBackground,
    inputBackground: brand.inputBackground,
    overlayBackground: brand.overlayBackground,

    // Text
    primaryText: brand.primaryText,
    secondaryText: brand.secondaryText,
    mutedText: brand.mutedText,

    // Pills / navigation
    pillBackground: brand.pillBackground,
    pillBorder: brand.pillBorder,
    navBackground: brand.navBackground,
    navBorder: brand.navBorder,
    navText: brand.navText,
    navActiveText: brand.navActiveText,

    // Green accent
    accentColor: brand.accentColor,
    accentLight: brand.accentLight,
    accentBorder: brand.accentBorder,

    // Coral action
    actionColor: brand.actionColor,
    actionLight: brand.actionLight,
    actionBorder: brand.actionBorder,

    // Raw brand values
    teal: brand.green,
    tealLight: brand.greenLight,
    tealMid: brand.greenMid,
    tealBorder: brand.greenBorder,
    tealStrong: brand.greenStrong,
    coral: brand.coral,
    coralLight: brand.coralLight,
    coralMid: brand.coralMid,
    coralBorder: brand.coralBorder,

    // Icon tile
    iconTile: brand.secondaryText,

    // Typography — font families only; weight + style set at point of use
    // Fraunces: fontWeight 500/400 = Regular, 600 = SemiBold, 700/800/900 = Black
    // Satoshi:  fontWeight 400 = Regular (italic via fontStyle), 500 = Medium, 700 = Bold
    fontHeading: "'Fraunces', Georgia, serif",
    fontBody:    "'Satoshi', system-ui, sans-serif",
  };
}